export default {
    data() {
        return {
            grouped: false,
            hidden: false,
        };
    },
    computed: {
        isCase() {
            return (
                this.$route.name === 'works-vodyanoy' ||
                this.$route.name === 'works-id'
            );
        },
        list() {
            const defaultList = [],
                repeatable = { groups: [] };
            Object.keys(this.$refs).forEach((item) => {
                if (item.includes('mbItem')) {
                    console.log(item, item.innerText);
                    const text = this.$refs[item].querySelector(
                        '.t-case__footer-specialty',
                    ).textContent;
                    defaultList.push(text.slice(0, text.indexOf('\n')));
                }
            });

            for (let i = 0; i < defaultList.length; i += 1) {
                if (defaultList[i] === defaultList[i + 1]) {
                    if (repeatable.groups.length === 0) {
                        repeatable.groups.push({
                            text: defaultList[i],
                            index: [i, i + 1],
                        });
                        repeatable.disabled = [i, i + 1];
                    } else {
                        let unic = true;
                        // eslint-disable-next-line no-loop-func
                        repeatable.groups.forEach((item) => {
                            if (item.index.includes(i)) {
                                item.index.push(i + 1);
                                repeatable.disabled.push(i + 1);
                                unic = false;
                            }
                        });
                        if (unic) {
                            repeatable.groups.push({
                                text: defaultList[i],
                                index: [i, i + 1],
                            });
                            repeatable.disabled.push(i, i + 1);
                        }
                    }
                }
            }

            return repeatable;
        },
    },
    methods: {
        show(id) {
            this.$refs[`mbItem_${id}`].classList.toggle(
                't-case__footer-item_show',
            );
        },
        toggle(event) {
            console.log(event);
            event.target
                .closest('.t-case__footer-budget')
                .classList.toggle('t-case__footer_show-budget');
        },
        hideRepeats() {
            const mobileSize = window.innerWidth < 920;
            if (mobileSize && !this.grouped) {
                this.grouped = !this.grouped;
                this.hidden = !this.hidden;
                this.list.groups.forEach((element) => {
                    const newItem = document.createElement('div'),
                        newSpec = this.$refs[`mbItem_${element.index[0]}`]
                            .querySelector('.t-case__footer-specialty')
                            .cloneNode(true);
                    newSpec.addEventListener('click', (event) => {
                        console.log(event);
                        event.target
                            .closest('.t-case__footer-item')
                            .classList.toggle('t-case__footer-item_show');
                    });
                    newItem.className =
                        't-case__footer-item t-case__footer-group';
                    // newSpec.onclick(this.show(this.list[0].disabled[0]))
                    newItem.append(newSpec);
                    element.index.forEach((id) => {
                        this.$refs[`mbItem_${id}`].style = 'display: none';
                        const newPerson = this.$refs[`mbItem_${id}`]
                            .querySelector('.t-case__footer-person')
                            .cloneNode(true);
                        const newImg = this.$refs[`mbItem_${id}`]
                            .querySelector('.t-case__footer-img')
                            .cloneNode(true);
                        newItem.append(newImg, newPerson);
                    });

                    this.$el
                        .querySelector('.t-case__footer-mb-wrapper')
                        .append(newItem);
                });
            }
            if (mobileSize && this.grouped && !this.hidden) {
                this.hidden = !this.hidden;
                this.list.disabled.forEach((item) => {
                    this.$refs[`mbItem_${item}`].style = 'display: none';
                });
                // eslint-disable-next-line no-param-reassign
                this.$el
                    .querySelectorAll('.t-case__footer-group')
                    .forEach((elem) => {
                        // eslint-disable-next-line no-param-reassign
                        elem.style = 'display: grid';
                    });
            }
            if (!mobileSize && this.grouped && this.hidden) {
                this.hidden = !this.hidden;
                this.list.disabled.forEach((item) => {
                    this.$refs[`mbItem_${item}`].style = 'display: grid';
                });
                // eslint-disable-next-line no-param-reassign
                this.$el
                    .querySelectorAll('.t-case__footer-group')
                    .forEach((elem) => {
                        // eslint-disable-next-line no-param-reassign
                        elem.style = 'display: none';
                    });
            }
        },
    },
    mounted() {
        this.hideRepeats();
        window.addEventListener('resize', () => this.hideRepeats());
    },
    updated() {
        this.hideRepeats();
    },
};
